export default {
  title: '保密协议',
  dialog: {
    cancel: '取消',
    agree: '同意',
  },
}
